const text = {
  alertMessage: '¿No sabes cómo organizar tu catálogo?  ',
  openModal: 'Ver un ejemplo',
  title: 'Crea tu catálogo',
  message: 'Agrega productos y vende más rápido.',
  addButton: 'Crear catálogo'
};
export default text;
